module.exports = __webpack_public_path__ + "static/media/Fast Delivary.ab4ad7da.png";